import { render, staticRenderFns } from "./HighlightsSlider.vue?vue&type=template&id=173f0fe8&"
import script from "./HighlightsSlider.vue?vue&type=script&lang=js&"
export * from "./HighlightsSlider.vue?vue&type=script&lang=js&"
import style0 from "./HighlightsSlider.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HighlightsSlider.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./HighlightsSlider.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports